import { useContext, useEffect } from 'react';
import { BetSlipContext } from '../../store/context';

export const useExposeBetslipApi = () => {
  const [, { ADD_TO_STORE, DELETE_FROM_STORE, FETCH_STORE }] =
    useContext(BetSlipContext);

  useEffect(() => {
    /**
     * @param {Array<{ serviceId, eventId, marketId, outcomeId }>} outcomeParams
     * @returns {Promise | null}
     */
    window.addBetslipOutcomes ??= (outcomeParams = []) => {
      if (outcomeParams.length === 0) {
        return null;
      }

      return ADD_TO_STORE({ bets: outcomeParams });
    };

    /**
     * @param {Array<{ outcomeId }>} items
     * @returns {Promise|null}
     */
    window.removeBetslipItems ??= (items) => {
      try {
        if (!items?.length) {
          return null;
        }

        DELETE_FROM_STORE({
          bets: items.map((outcomeId) => ({ outcomeId }))
        });

        return 'Provided outcomes were removed';
      } catch {
        return null;
      }
    };

    /**
     * @returns {Array<{ serviceId, eventId, marketId, outcomeId }>}
     */
    window.getBetslipItems ??= async () => {
      try {
        const {
          data: { betslip }
        } = await FETCH_STORE();

        return betslip.bets;
      } catch {
        return null;
      }
    };
  }, [ADD_TO_STORE, DELETE_FROM_STORE, FETCH_STORE]);
};
